import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=3bce98b0&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=3bce98b0&scoped=true&lang=css&"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=3bce98b0&scoped=true&lang=css&"
import style2 from "./Welcome.vue?vue&type=style&index=2&id=3bce98b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bce98b0",
  null
  
)

export default component.exports